import { Link } from 'react-router-dom';

const SetPasswordSucceed = () => (
  <div className="container container--x-narrow py-primary">
    <h3 className="mb-3">Password reset</h3>
    <div className="alert alert-success d-flex align-items-start" role="alert">
      <i className="fas fa-check-circle icon__before-text text-success" />
      Your password has been successfully reset
    </div>
    <Link to="/account/login">Go back to login</Link>
  </div>
);

export default SetPasswordSucceed;
